import { useContext } from "react";
import { NavigationContext, NavigationContextProps } from "go-app/components/Navigation/NavigationContext";

export const useNavigationContext = (): NavigationContextProps => useContext(NavigationContext);
